import { render, staticRenderFns } from "./TeacherNav.vue?vue&type=template&id=3723bc6f&scoped=true&"
import script from "./TeacherNav.vue?vue&type=script&lang=js&"
export * from "./TeacherNav.vue?vue&type=script&lang=js&"
import style0 from "./TeacherNav.vue?vue&type=style&index=0&id=3723bc6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3723bc6f",
  null
  
)

export default component.exports